import { Abonnement } from "src/app/models/abonnement";
import { EUserType } from "../enum/e-user-type";
import { Observable } from "rxjs";
import { Package } from "../../packages/models/package";
import { Injector } from "@angular/core";
import { Subscription } from "../../subscription/models/subscription";


export abstract class User  {
    
    id: string;
    userName: string;
    name : string;
    firstName : string;
    picture : string | null;
    email: string;
    phoneNumber: string;
    inserDate : Date;
    updateDate : Date;
    role: Array<string>;
    users: Array<User> | null;
    formuleId: number;
    abonnements : Abonnement[];
    isActive : boolean;
    colorCode = "";

    abstract discriminator: EUserType

    constructor(public injector: Injector) {
        this.id             = "";
        this.userName       = "";
        this.name           = "";
        this.firstName      = "";
        this.picture        = "";
        this.email          = "";
        this.phoneNumber    = "";
        this.inserDate      = new Date();
        this.updateDate     = new Date();
        this.role           = new Array<string>();
        this.users          = new Array<User>();
        this.formuleId      = 0;
        this.abonnements    = new Array<Abonnement>();
        this.isActive       = false;
    }

    abstract getPackage(): Observable<Package[]>;

    abstract getSubscriptions(): Observable<Subscription[]>;


}
